import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import cx from 'classnames';
import { Ellipsis } from '@common/components/Ellipsis';
import { Loading } from "@common/components/loading";
import { sanitize } from "@common/utils/sanitize";

import "./questionnaires.styles.scss";

export const Questionnaires = (props) => {
  const { moduleName, selectedQuestionnaire, onSelectedQuestionnaireChange, title, columns: propsColumns, getFhq4Value, getIdValue, classes } = props;
  const localModuleName = `${moduleName}-questionnaires-list`;
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    props.getData().then(setData);
  }, []);

  const columns = propsColumns || React.useMemo(
    () =>
      [
        { name: "Questionnaire Name", id: "questionnaireName", fieldName: "questionnaireName", width: '50%', className: "Questionnaires__table__body__row__cell--name" },
        { name: "FHQ Version", id: "fhqV", width: '50%', render: (item) => `FHQ${item.fhq4 ? 4 : 3}` },
      ].map((x) => ({ ...x, name: I18n.t(x.name) })),
    []
  );
  
  return (
    <div className="Questionnaires">
      <h6 className="Questionnaires__title">{title}</h6>
      {!data.length && (
        <Flex alignItems="center" justify="center" className="Questionnaires__loading">
          <Loading size={25} />
        </Flex>
      )}
      {Boolean(data.length) && (
        <div className="Questionnaires__table">
          <Flex
            justify="space-between"
            alignItems="center"
            className="Questionnaires__table__header"
          >
            {columns.map((x) => (
              <span key={x.id} style={{ width: x.width }} className="Questionnaires__table__header__cell">
                {x.name}
              </span>
            ))}
          </Flex>
          <div className={cx("Questionnaires__table__body", classes?.body)}>
            {data.map((item, rowIndex) => {
              const isSelected = (
                getIdValue(item) && 
                (getIdValue(item) === getIdValue(selectedQuestionnaire)) && 
                (Boolean(getFhq4Value(item)) === Boolean(getFhq4Value(selectedQuestionnaire)))
              );
              
              return (
                <Flex
                  justify="space-between"
                  alignItems="center"
                  key={rowIndex}
                  className={cx("Questionnaires__table__body__row", { "Questionnaires__table__body__row-selected": isSelected })}
                  onClick={isSelected ? undefined : (() => onSelectedQuestionnaireChange(item))}
                  {...getTestAttributes(localModuleName, "item", "row", getIdValue(item))}
                >
                  {columns.map((col, colIndex) => {
                    const isNameColumn = col.fieldName === 'questionnaireName';
                    const imgWidth = 16;
                    const imgMargin = 4;

                    return (
                      <React.Fragment key={col.id}>
                        {isNameColumn && <img src="gif/questionnaire.gif" style={{ marginRight: imgMargin, marginLeft: imgMargin }} width={imgWidth} />}
                        <Ellipsis 
                          {...getTestAttributes({ id: `tbl-bwstep-quest-invite-grid-${rowIndex}-${colIndex}` })}
                          className={cx("Questionnaires__table__body__row__cell", col.className)} 
                          width={isNameColumn ? `calc(${col.width} - ${imgWidth + imgMargin * 2}px)` : col.width} 
                          text={col.render ? sanitize(col.render(item)) : sanitize(item[col.fieldName])} 
                        />
                      </React.Fragment>
                    );
                  })}
                </Flex>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

Questionnaires.defaultProps = {
  getFhq4Value: (item) => item?.fhq4,
  getIdValue: (item) => item?.questionnaireId,
};